// ======================================================================
// FILE:
// src/modules/service_crm/services/serviceSatisfactionService.js
//
// MODULE: Service CRM
// FEATURE: Customer Satisfaction APIs
// ======================================================================

import axiosClient from "../../../api/axiosClient";


// ======================================================================
// LIST SATISFACTION QUEUE
// ======================================================================
const listSatisfaction = async (
  params = {}
) => {

  const res = await axiosClient.get(
    "/api/service-crm/satisfaction",
    {
      params,
    }
  );

  return res.data.data;
};


// ======================================================================
// GET SATISFACTION BY TICKET
// ======================================================================
const getSatisfaction = async (
  ticketId
) => {

  const res = await axiosClient.get(
    `/api/service-crm/tickets/${ticketId}/satisfaction`
  );

  return res.data.data;
};


// ======================================================================
// CREATE SATISFACTION
// ======================================================================
const createSatisfaction = async (
  ticketId,
  payload
) => {

  const res = await axiosClient.post(
    `/api/service-crm/tickets/${ticketId}/satisfaction`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// UPDATE SATISFACTION
// ======================================================================
const updateSatisfaction = async (
  satisfactionId,
  payload
) => {

  const res = await axiosClient.put(
    `/api/service-crm/satisfaction/${satisfactionId}`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// EXPORT
// ======================================================================
const serviceSatisfactionService = {

  listSatisfaction,

  getSatisfaction,

  createSatisfaction,

  updateSatisfaction,
};

export default serviceSatisfactionService;